import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { useFilterBarValues, ValueKey } from '../FilterBar.context'
import { FilterDropdown } from './FilterDropdown'

// Generic component that can work with any filter parameter, filter name, and value type
//
// Usage examples:
//
// 1. Basic usage with string arrays (like organizations):
// <GenericFilterDropdown
//   filterParam={FilterParam.ORGANIZATION}
//   filterName={FilterName.ORGANIZATION}
//   valueKey="organizations"
// />
//
// Note: Register the transformation function in the context provider:
// useFilterBarValues().registerTransform(FilterParam.ORGANIZATION, (organizations) =>
//   organizations.map(org => ({
//     value: org,
//     label: org
//   }))
// )
export const GenericFilterDropdown = React.memo(
  <T extends ValueKey>({
    filterParam,
    filterName,
    valueKey,
    isNested = false,
  }: {
    filterParam: FilterParam
    filterName: FilterName
    valueKey: T
    isNested?: boolean
  }): JSX.Element => {
    const filterBarValues = useFilterBarValues()

    // Transform values using the valueKey
    const filterValues = filterBarValues.transformFilter(filterParam, valueKey)

    return (
      <FilterDropdown
        filterParam={filterParam}
        filterName={filterName}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
